import { ErrorBoundary } from "react-error-boundary";
import Modal from "@/shared/ui/modal/Modal";
import { ATMErrorFallback } from "@/domains/bank/components/ATMErrorFallback";
import { BankATM } from "@/domains/bank/components/BankATM/BankATM";
import { BankCharacter } from "@/domains/bank/types";

type BankATMModalProps = {
  open: boolean;
  onClose: () => void;
  atmId: number | null;
  bankCharacter: BankCharacter;
  hasAccount: boolean;
  isLoading: boolean;
};

export function BankATMModal({
  open,
  onClose,
  atmId,
  bankCharacter,
  hasAccount,
  isLoading,
}: BankATMModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="w-fit p-0 bg-dark-900 rounded-[1rem] overflow-hidden"
      classNameCloseBtn="top-10 right-10 size-8 p-0 rounded-xl bg-white text-dark-800 hover:brightness-90"
      overlay={false}
      style={{
        boxShadow: "0px 0px 200px 0px rgba(34, 139, 34, 0.60)",
        fontFamily: "TT Norms Pro",
      }}
    >
      <ErrorBoundary fallback={<ATMErrorFallback />}>
        <BankATM
          bankCharacter={bankCharacter}
          hasAccount={hasAccount}
          isLoading={isLoading}
          atmId={atmId}
        />
      </ErrorBoundary>
    </Modal>
  );
}
